export default {
    punchLog: 'บันทึกการเข้าออก',
    searchByEmployeeNoOrName: 'ค้นหาโดยรหัสพนักงานหรือชื่อ',
    search: 'ค้นหา',
    employeeNo: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    date: 'วันที่',
    time: 'เวลา',
    startDate: 'วันเริ่มต้น',
    endDate: 'วันสิ้นสุด'
}
